export const AVERGAE_JOB_VALUE_PROPS = {
  label: 'Average Job Value',
  placeholder: 'average job value',
  wrapperProps: {
    className: 'mr-2',
  },
  type: 'price',
};
